let startPositionBottomBar = 0;
const productBar = document.querySelector('.product--bottom-bar');

document.addEventListener('scroll', (event) => {
    startPositionBottomBar = window.scrollY;

    if (startPositionBottomBar > 250) {
        productBar.classList.add('show')
    } else {
        productBar.classList.remove('show')
    }
});

const buttonLink = document.querySelector('.button--scroll-to-buy');
buttonLink.addEventListener('click', function (e) {
    e.preventDefault();
    let linkRef = this.getAttribute('href');
    document.querySelector(linkRef).scrollIntoView(
        {behavior: 'smooth',  block: 'start'}
    );
    history.replaceState({}, document.title, window.location.href.split("#")[0]);
});

window.addEventListener('scroll', function() {
    let blockToPath = document.querySelector('.product__info-container .product-form');
    let buttonScrollBarMob = document.querySelector('.button--scroll-bar');

    if (blockToPath.getBoundingClientRect().bottom <= 50) {
        buttonScrollBarMob.classList.add('show')
    } else {
        buttonScrollBarMob.classList.remove('show')
    }
});
